import { render, staticRenderFns } from "./PaymentDetailSWIFT.vue?vue&type=template&id=5360a27d&"
import script from "./PaymentDetailSWIFT.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailSWIFT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports